import PropTypes from 'prop-types';
import 'intersection-observer';
import './styles.css';
import { SURVEYS_QUESTION_TYPES } from '../constants';
import InputSelect from './InputSelect';
import GridSelect from './GridSelectView';
import MultiSelect from './MultiSelectView';
import SingleSelect from './SingleSelectView';
import { getLocalizedDate } from '../../../helpers/localize';
import { makeStyles, Typography } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  modal: {
    width: '100%',
    maxWidth: 1000,
    padding: '0 40px 40px 40px',
  },
  modalContainer: {
    width: '100%',
    maxWidth: 1000,
  },

  date: {
    marginLeft: theme.spacing(2),
    marginBottom: theme.spacing(1),
    fontWeight: 500,
    color: theme.palette.text.secondary,
  },
  resultText: {
    marginLeft: theme.spacing(2),
    marginBottom: theme.spacing(1),
    fontWeight: 500,
    color: theme.colors.blue2,
  },

  sectionTitle: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
    fontWeight: 500,
    color: theme.colors.blue2,
    fontSize: '1.2rem',
  },

  title: {
    fontSize: '1rem !important',
    color: theme.colors.blue2,
    fontWeight: 500,
  },
  titleDate: {
    fontSize: '.7rem !important',
    color: theme.colors.blue2,
  },
}));

const DATE_TITLE = {
  today: 'Today',
  less30days: '0-30 Days Ago',
  more30days: '30-90 Days Ago',
  more91days: '91+ Days Ago',
};
const ReportViewTable = ({
                           surveyList,
                           termsAcceptedTimestamp,
                           counterColoredAnswers,
                           isComparing = false,
                           baseCompletedTimestamp = null,
                           currentCompletedTimestamp = null,
                         }) => {
  const getDateSubTitle = (date_as_string) => {
    const today = new Date();
    const date = new Date(date_as_string);
    const diffTime = Math.abs(today - date);
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

    let diffDaysTitle = DATE_TITLE.more91days;

    if (diffDays < 1) {
      diffDaysTitle = DATE_TITLE.today;
    } else if (diffDays < 30) {
      diffDaysTitle = DATE_TITLE.less30days;
    } else if (30 <= diffDays <= 90) {
      diffDaysTitle = DATE_TITLE.more30days;
    }

    return `(${diffDaysTitle})`;
  };

  const classes = useStyles();

  return (
    <>
      {surveyList.length > 0 && (
        <table className={isComparing ? 'styled_comparing_table' : 'styled_table'}>
          {
            isComparing ?
              <tr className='list-break-marker'>
                <th></th>
                <th>
                  <Typography className={classes.title}>
                    {'Assessment 1'}
                  </Typography>
                  <Typography className={classes.titleDate} style={{
                    flex: 1,
                    flexShrink: 1,
                  }}>
                    {getLocalizedDate(baseCompletedTimestamp, 'UTC')}
                  </Typography>
                  <Typography className={classes.titleDate} style={{
                    flex: 1,
                    flexShrink: 1,
                  }}>
                    {getDateSubTitle(baseCompletedTimestamp)}
                  </Typography>
                </th>
                <th>
                  <Typography className={classes.title}>
                    {'Assessment 2'}
                  </Typography>
                  <Typography className={classes.titleDate} style={{
                    flex: 1,
                    flexShrink: 1,
                  }}>
                    {getLocalizedDate(currentCompletedTimestamp, 'UTC')}
                  </Typography>
                  <Typography className={classes.titleDate} style={{
                    flex: 1,
                    flexShrink: 1,
                  }}>
                    {getDateSubTitle(currentCompletedTimestamp)}
                  </Typography>
                </th>
                <th style={{
                  color: '#122056',
                  fontSize: '1rem',
                  fontWeight: 500,
                }}>
                  {'Result'}
                </th>
              </tr> : <tr className='list-break-marker'>
                <th></th>
                <th>
                  <div className='dot green-dot-bgcolor'>
                    {counterColoredAnswers.success}
                  </div>
                </th>
                <th>
                  <div className='dot orange-dot-bgcolor'>
                    {counterColoredAnswers.warning}
                  </div>
                </th>
                <th>
                  <div className='dot red-dot-bgcolor'>
                    {counterColoredAnswers.error}
                  </div>
                </th>
                <th>
                  <div className='dot black-dot-bgcolor'>
                    {counterColoredAnswers.info}
                  </div>
                </th>
              </tr>
          }
          {surveyList.length > 0 &&
          surveyList.map((survey) => {

            if (
              survey.itemType === SURVEYS_QUESTION_TYPES.Table
            ) {
              return <SingleSelect survey={survey} isComparing={isComparing} isTable={true} />;
            }
            if (
              survey.itemType === SURVEYS_QUESTION_TYPES.input
            ) {
              return <InputSelect survey={survey} isComparing={isComparing} />;
            }
            if (
              survey.itemType === SURVEYS_QUESTION_TYPES.GridSelect ||
              survey.itemType === SURVEYS_QUESTION_TYPES.GridNumericalSelector
            ) {
              return <GridSelect survey={survey} isComparing={isComparing} />;
            }
            if (
              survey.itemType === SURVEYS_QUESTION_TYPES.ClockTest ||
              survey.itemType === SURVEYS_QUESTION_TYPES.BasicNumericalSelector
            ) {
              return <SingleSelect survey={survey} isComparing={isComparing} termsAcceptedTimestamp={termsAcceptedTimestamp}/>;
            }
            if (
              survey.values ||
              survey.itemType === SURVEYS_QUESTION_TYPES.MultiSelect ||
              survey.baseValues ||
              survey.currentValues
            ) {
              return <MultiSelect survey={survey} isComparing={isComparing} />;
            }
            return <SingleSelect survey={survey} isComparing={isComparing} />;
          })}
        </table>
      )}
    </>
  );
};

ReportViewTable.propTypes = {
  surveyList: PropTypes.arrayOf(PropTypes.object),
  counterColoredAnswers: PropTypes.shape({
    success: PropTypes.number,
    warning: PropTypes.number,
    error: PropTypes.number,
    info: PropTypes.number,
  }).isRequired,
};

ReportViewTable.defaultProps = {
  surveyList: [],
};

export default ReportViewTable;
